import axios from 'axios'

// const baseURL = 'https://graph.microsoft.com/v1.0/me' //mGraph endpoint

export const api = axios.create({
  baseURL: process.env.REACT_APP_APIURL,
})
